import React from "react";
import {
  Box,
  Container,
  Heading,
  VStack,
  Text,
  useColorModeValue,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaComments } from "react-icons/fa";
export const AgentChat: React.FC = () => {
  const { t } = useTranslation();
  const bgColor = useColorModeValue("gray.50", "gray.900");

  const handleChat = () => {
    // This is an injected widget from external script
    // @ts-ignore
    if (window.ArariaChat) {
      // @ts-ignore
      window.ArariaChat.toggleChatWindow(true);
    }
  };

  return (
    <Box py={20} bg={bgColor}>
      <Container maxW="container.lg">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Text color="brand.primary" fontWeight="bold" fontSize="lg">
              {t("home.agentChat.subtitle")}
            </Text>
            <Heading
              size="2xl"
              fontFamily="Nasalization"
              bgGradient="linear(to-r, brand.primary, brand.secondary)"
              bgClip="text"
            >
              {t("home.agentChat.title")}
            </Heading>
            <Button
              colorScheme="brand"
              size="lg"
              leftIcon={<FaComments />}
              onClick={() => handleChat()}
            >
              {t("home.agentChat.button")}
            </Button>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};
